import styles from '@/styles/auth/leadscale.module.css';

/** Compact lime LS mark for login/register headers. */
export function LeadScaleMark({ className = '' }) {
  return (
    <div className={`${styles.markCompact} ${className}`.trim()} aria-hidden="true">
      <span>LS</span>
      <small>LEADSCALE</small>
    </div>
  );
}

/**
 * Full orbits visual from leadscaleglobal.com hero.
 * @param {{ className?: string, highlight?: 'affiliate' | 'advertiser' | null }} props
 */
export function SignalStage({ className = '', highlight = null }) {
  const affiliateHi = highlight === 'affiliate' ? styles.nodeHighlight : '';
  const advertiserHi = highlight === 'advertiser' ? styles.nodeHighlight : '';
  return (
    <div
      className={`${styles.signalStage} ${className}`.trim()}
      aria-label="LeadScale global network visual"
    >
      <div className={styles.orbitOne} />
      <div className={styles.orbitTwo} />
      <div className={styles.orbitThree} />
      <div className={styles.signalCore}>
        <span>LS</span>
        <small>GLOBAL NETWORK</small>
      </div>
      <div className={`${styles.nodeA} ${affiliateHi}`.trim()}>
        <i />
        <span>Affiliate</span>
      </div>
      <div className={styles.nodeB}>
        <i />
        <span>Qualified lead</span>
      </div>
      <div className={`${styles.nodeC} ${advertiserHi}`.trim()}>
        <i />
        <span>Advertiser</span>
      </div>
      <div className={styles.pulseCard}>
        <small>Connection status</small>
        <strong>
          <i />
          <span>Ready to scale</span>
        </strong>
      </div>
    </div>
  );
}

export function LeadScaleBrandWordmark() {
  return (
    <div className={styles.brandRow}>
      <div className={styles.markCompact} style={{ width: 40, height: 40, margin: 0, boxShadow: 'rgba(200,255,53,0.2) 0 0 20px' }}>
        <span style={{ fontSize: 14 }}>LS</span>
      </div>
      <div className={styles.brandCopy}>
        <strong>LeadScale</strong>
        <small>Global Partner</small>
      </div>
    </div>
  );
}
